import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import { isAdminAuthed } from '@/utils/adminAuth'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/admin/login',
    name: 'admin-login',
    component: () => import(/* webpackChunkName: "admin-login" */ '../views/admin/AdminLogin.vue'),
    meta: { adminPublic: true },
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import(/* webpackChunkName: "admin" */ '../views/admin/AdminView.vue'),
    meta: { requiresAdminAuth: true },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const isAdminRoute = to.path === '/admin' || to.path.startsWith('/admin/')
  if (!isAdminRoute) {
    next()
    return
  }

  if (to.meta && to.meta.adminPublic) {
    if (isAdminAuthed() && to.name === 'admin-login') {
      const redirect = typeof to.query.redirect === 'string' ? to.query.redirect : '/admin'
      next(redirect)
      return
    }
    next()
    return
  }

  if (to.meta && to.meta.requiresAdminAuth && !isAdminAuthed()) {
    next({
      name: 'admin-login',
      query: { redirect: to.fullPath },
    })
    return
  }

  next()
})

export default router
